import { useState } from 'react';
import type { FormFieldDef } from '@hcc/types';

interface UploadConfigProps {
  draft: FormFieldDef;
  patch: (p: Partial<FormFieldDef>) => void;
}

const inputClass =
  'mt-1 block w-full rounded-token-sm border border-line-strong/20 bg-surface px-3 py-2 text-sm';

/** Config for file_upload fields: allowed extensions and multi-file toggle. */
export function UploadConfig({ draft, patch }: UploadConfigProps) {
  // Raw text for the comma-separated "allowed file types" box. Kept separate
  // from draft.accept (the parsed array) so typing a comma or space isn't
  // collapsed away as you type the next extension.
  const [acceptText, setAcceptText] = useState((draft.accept ?? []).join(', '));

  return (
    <>
      <label className="block text-sm">
        <span className="font-medium text-fg-muted">Allowed file types</span>
        <input
          value={acceptText}
          onChange={(e) => {
            setAcceptText(e.target.value);
            patch({
              accept: e.target.value
                .split(',')
                .map((s) => s.trim().toLowerCase())
                .filter(Boolean),
            });
          }}
          className={inputClass}
          placeholder="pdf, jpg, png, docx, zip"
        />
        <span className="mt-1 block text-xs text-fg-dim">
          Comma-separated extensions. Executables are always blocked.
        </span>
      </label>
      <label className="flex items-center gap-2 text-sm text-fg">
        <input
          type="checkbox"
          checked={!!draft.multiple}
          onChange={(e) => patch({ multiple: e.target.checked })}
        />
        Allow multiple files
      </label>
    </>
  );
}
